import { useMemo } from 'react'
import { Order } from '../../store/orders/orders.types'
import { MenuItem, MenuList } from '@mui/material'

export const isOrderDetailsIncomplete = (order: Order): boolean => {
  const { customerName, loadNumber, billingEmail, baseRate, orderEvents } = order
  return (
    customerName === '' ||
    loadNumber === '' ||
    billingEmail === '' ||
    baseRate?.toString() === '' ||
    orderEvents?.some(
      (event) =>
        event?.startTime === '' ||
        !event?.startTime ||
        event?.endTime === '' ||
        !event?.endTime ||
        event.name === '' ||
        event.address === ''
    )
  )
}

export const useUpdateOrderConfirmationDialog = (order: Order) => {
  const { customerName, loadNumber, billingEmail, baseRate, orderEvents } =
    order

  const isError: boolean = useMemo(() => {
    return isOrderDetailsIncomplete(order)
  }, [order])

  const Message = () => (
    <MenuList>
      {customerName === '' && <MenuItem>Customer name is missing</MenuItem>}
      {loadNumber === '' && <MenuItem>Load number is missing</MenuItem>}
      {billingEmail === '' && <MenuItem>Billing email is missing</MenuItem>}
      {baseRate?.toString() === '' && <MenuItem>Base rate is missing</MenuItem>}
      {orderEvents?.map(({ startTime, endTime, eventType, name, address }) => (
        <>
          {(!startTime || startTime === '') && eventType === 'PICKUP' && (
            <MenuItem>Pickup start date and time is missing</MenuItem>
          )}
          {(!endTime || endTime === '') && eventType === 'PICKUP' && (
            <MenuItem>Pickup end date and time is missing</MenuItem>
          )}
          {(!startTime || startTime === '') && eventType === 'DELIVERY' && (
            <MenuItem>Delivery start date and time is missing</MenuItem>
          )}
          {(!endTime || endTime === '') && eventType === 'DELIVERY' && (
            <MenuItem>Delivery end date and time is missing</MenuItem>
          )}
          {name === '' && eventType === 'PICKUP' && (
            <MenuItem>Pickup company name is missing</MenuItem>
          )}
          {address === '' && eventType === 'PICKUP' && (
            <MenuItem>Pickup company address is missing</MenuItem>
          )}
          {name === '' && eventType === 'DELIVERY' && (
            <MenuItem>Delivery company name is missing</MenuItem>
          )}
          {address === '' && eventType === 'DELIVERY' && (
            <MenuItem>Delivery company address is missing</MenuItem>
          )}
        </>
      ))}
    </MenuList>
  )

  return { isError, Message }
}
